// ---------------------------------------------------------------------------
// Job Postings
// ---------------------------------------------------------------------------
// To add a new job posting, add an entry to JOB_POSTINGS below.
//
// content.sections defines the body of the posting after the auto-generated
// intro. Each section has a title and either paragraphs, bullets, or both.
// Use **text** inside bullet strings to render bold inline text.
//
// Example:
// {
//   slug: "my-new-role",
//   title: "My New Role",
//   department: "Engineering",
//   location: "Remote",
//   type: "Full-time",
//   content: {
//     sections: [
//       {
//         title: "Job Overview",
//         paragraphs: ["Description of the role..."],
//       },
//       {
//         title: "Required Qualifications",
//         bullets: ["**3+ years** of experience with...", "Proficiency in **TypeScript**"],
//       },
//       {
//         title: "Preferred Qualifications",
//         subtitle: "Candidates with these qualifications will be given special consideration.",
//         bullets: ["Experience with **Electron**"],
//       },
//     ],
//   },
// },
// ---------------------------------------------------------------------------

export interface JobPostingSection {
  title: string;
  /** Optional subtitle rendered below the heading. */
  subtitle?: string;
  /** Plain text paragraphs rendered in order. */
  paragraphs?: string[];
  /** Bullet list items. Wrap text in **double asterisks** to render it bold. */
  bullets?: string[];
}

export interface JobPostingContent {
  sections: JobPostingSection[];
}

export interface JobPosting {
  /** URL-friendly identifier, e.g. "senior-engineer" → /careers/senior-engineer */
  slug: string;
  /** Display title shown on the listings page and the posting header. */
  title: string;
  /** Team or department name, e.g. "Engineering", "Marketing". */
  department: string;
  /** Work location, e.g. "Remote", "Austin, TX". */
  location: string;
  /** Employment type, e.g. "Full-time", "Part-time", "Contract". */
  type: string;
  content: JobPostingContent;
}

export const JOB_POSTINGS: JobPosting[] = [];
